export default "__VITE_PUBLIC_ASSET__33d0c9a1__"